// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4588":"032dc3c0","5585":"ad392cbd","6585":"e0051bcf","7316":"176ab93b"}[chunkId] + ".chunk.css";
};